import type {Dictionary} from "lodash";
import {useCallback, useMemo, useState} from "react";

import {PricingTierItem} from "../../../../store/slices/regionPricing";
import {FilterMap} from "./types";

export const merge = (prev: FilterMap, curr: string): FilterMap => ({
  ...prev,
  [curr]: false,
});

export const toFilterMap = (filters: string[]): FilterMap => filters.reduce(merge, {});

export const toggleFilter = (filter: string, filterMap: FilterMap): FilterMap => ({
  ...filterMap,
  [filter]: !filterMap[filter],
});

interface UseFiltersResponse {
  filters: FilterMap;
  // @ts-expect-error TS7010: 'toggleFilter', which lacks return-type annotation, implicitly has an 'any' return type.
  toggleFilter(filter: string);
}

export const useFilters = (initialFilters: string[]): UseFiltersResponse => {
  const defaultFilters = useMemo(() => toFilterMap(initialFilters), [initialFilters]);
  const [filters, setFilters] = useState(defaultFilters);
  const _toggleFilter = useCallback(
    (filter: string) => {
      setFilters(toggleFilter(filter, filters));
    },
    [filters],
  );

  return {filters, toggleFilter: _toggleFilter};
};

export const getFilteredGroupList = (
  prices: PricingTierItem[],
  filters: FilterMap,
  searchText = "",
  // @ts-expect-error TS7006: Parameter 'isVirtual' implicitly has an 'any' type.
  isVirtual,
): Dictionary<PricingTierItem[]> => {
  const activeFilters = filters.pickBy(item => item === true).getKeys();
  const filteredPrices: PricingTierItem[] = prices
    .filterIf(searchText.length > 0, ({name}) =>
      name.toLocaleLowerCase().includes(searchText.toLowerCase()),
    )
    .filterIf(isVirtual, ({name}) => name.toLocaleLowerCase().includes("virtual"))
    .filterIf(activeFilters.length > 0, ({typ}) => activeFilters.some(f => f === typ));

  return filteredPrices.groupBy("typ");
};
